module.exports = __webpack_public_path__ + "img/Principal.15aa82bf.png";